<script>
import { mapState, mapGetters, mapActions } from "vuex";
import moment from "@/utils/moment";

export default {
  props: {
    isToday: {
      type: Boolean,
      required: false,
      default: false
    },
    title: {
      type: [String, Boolean],
      required: false,
      default: false
    },
    initialHour: {
      type: Number,
      required: false,
      default: 7
    },
    finalHour: {
      type: Number,
      required: false,
      default: 22
    },
    startsAt: {
      type: Number,
      required: false
    },
    endsAt: {
      type: Number,
      required: false
    },
    maxDuration: {
      type: Number,
      required: false,
      default: 8
    }
  },

  data() {
    return {
      show: false,
      selectedEvent: null
    };
  },

  filters: {
    convertToHours(val) {
      return val < 10 ? `0${val}:00` : `${val}:00`;
    }
  },

  methods: {
    verifyStatus(hour) {
      if (
        this.isToday &&
        moment()
          .add(3, "hours")
          .format("HH") > hour
      )
        return "inactive";

      if (
        (hour <= this.endsAt && hour >= this.startsAt) ||
        hour === this.startsAt
      )
        return "active";

      if (
        this.startsAt &&
        (this.startsAt + this.maxDuration < hour || this.startsAt > hour)
      )
        return "inactive";
    },

    select(val) {
      if (this.verifyStatus(val) === "inactive") return;

      if (this.startsAt && !this.endsAt && val > this.startsAt) {
        this.$emit("endSelected", val);
        this.show = false;
      } else if (val === this.startsAt) {
        this.selectedEvent = null;
        this.$emit("startSelected", null);
      } else {
        this.$emit("startSelected", val);
      }
    },

    range(start, end) {
      return Array(end - start + 1)
        .fill()
        .map((_, idx) => start + idx);
    }
  }
};
</script>

<template>
  <div class="section general">
    <div v-if="title" class="section-title mt-20">
      {{ title }}
      <hr />
    </div>

    <div class="period" @click="show = !show">
      <span v-if="!startsAt">selecione a hora inicial</span>
      <span v-else-if="!endsAt">selecione a hora final</span>
      <span v-else>{{ startsAt }}hrs às {{ endsAt }}hrs</span>
    </div>

    <transition name="fade" mode="out-in">
      <div class="select" v-show="show">
        <ul>
          <li
            v-for="(hour, index) in range(initialHour, finalHour)"
            :key="index"
            @click="select(hour)"
            :class="verifyStatus(hour)"
          >
            {{ hour | convertToHours }}
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<style scoped>
.general {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.period {
  padding: 10px 20px 10px 50px;
  background-position: 15px center;
  background-size: 20px;
  background-repeat: no-repeat;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 10px;
  user-select: none;
}

.select {
  background: #fff;
  display: flex;
  justify-content: center;
  text-align: center;
  border: 1px solid #ddd;
  border-radius: 4px;
  position: relative;
  width: 220px;
}

.select div {
  display: flex;
  flex-direction: row;
}

.select .buttons {
  justify-content: flex-end;
}

ul {
  flex: 1;
  padding: 0;
  list-style: none;
  width: 50%;
}

ul li {
  width: 100%;
  height: 30px;
  line-height: 30px;
  cursor: pointer;
  user-select: none;
}

ul li:hover {
  background-color: #eee;
}

ul li.active {
  color: #fff;
  background-color: var(--pink);
}

ul li.inactive {
  color: #ddd;
  cursor: auto;
}

ul li.title {
  cursor: auto;
  font-weight: 600;
  font-size: 12px;
  margin-bottom: 15px;
}

ul li.inactive:hover,
ul li.title:hover {
  background: transparent;
}

.period {
  background-image: url("/static/icon-time.svg");
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/TimePicker.vue